/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { DetailHeader, InputField, SelectField } from 'cx-ui-components';
import DetailWrapper from '../../../components/DetailWrapper';
import styled from 'styled-components';
import VersionSection from './components/VersionSection';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const WrappedDetailHeader = styled(DetailHeader)`
  margin-left: 35px;
`;

export default function AlpsForm({
  initialValues,
  handleSubmit,
  isSaving,
  artifactTypes,
  actionTypes,
  artifactSubtypes,
  selectableVersions,
  userHasUpdatePermission,
  isCreatingEntity,
  typeHasSubtypes,
  key,
  inherited
}) {
  return (
    <form onSubmit={handleSubmit} key={key}>
      <Wrapper>
        <DetailWrapper open data-automation="groupsDetailsSVG">
          <WrappedDetailHeader text="Details" />
          <InputField
            name="name"
            label="Name *"
            id="frm-groups-name"
            data-automation="nameInput"
            componentType="input"
            inputType="text"
            disabled={isSaving || inherited || !isCreatingEntity}
          />
          <InputField
            name="description"
            label="Description *"
            id="frm-groups-description"
            data-automation="descriptionInput"
            componentType="textarea"
            inputType="text"
            disabled={isSaving || !isCreatingEntity}
          />
          <SelectField
            name="artifactTypeId"
            label="Artifact Type *"
            placeholder="Select type..."
            data-automation="artifactTypeList"
            disabled={isSaving || !isCreatingEntity}
            options={[
              {
                label: 'Select type...',
                value: '',
              },
              ...artifactTypes,
            ]}
            required
          />
          {typeHasSubtypes && (
            <SelectField
              name="artifactSubType"
              label="Artifact Subtype *"
              placeholder="Select subtype..."
              data-automation="artifactSubtypeList"
              disabled={isSaving || !isCreatingEntity}
              options={[
                {
                  label: 'Select subtype...',
                  value: '',
                },
                ...artifactSubtypes,
              ]}
              required
            />
          )}
           {!isCreatingEntity && (
            <SelectField
              name="version"
              label="Active Version *"
              options={selectableVersions}
              data-automation="activeVersionDropDownList"
              disabled={isSaving || !userHasUpdatePermission}
            />
          )}
         {/* {isCreatingEntity && <VersionSection actionTypes={actionTypes} disabled={isSaving} />}
          */}
          </DetailWrapper> 
      </Wrapper>
    </form>
  );
}

AlpsForm.propTypes = {
  key: PropTypes.string,
  actionTypes: PropTypes.array,
  artifactTypes: PropTypes.any,
  artifactSubtypes: PropTypes.array,
  currentFormValues: PropTypes.object,
  handleSubmit: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
  isCreatingEntity: PropTypes.bool,
  userHasUpdatePermission: PropTypes.bool,
};
